export var USER_REPOSITORY = 'USER_REPOSITORY';